import { createContext, Dispatch, SetStateAction } from 'react'

import { ConfigurationBaseOptions } from '@taxfix/scouts-books'
import { CountryCode, CurrencyCode, CurrencySymbol, Locale, TimeZone } from '@taxfix/scouts-helpers'

import config from '@/config'
import { CURRENCY, PATH_FINANCES } from '@/constants'
import { featureFlags } from '@/feature-flags'
import { getBaseUrl, getFullBasenamePath } from '@/helpers/url-domain'

import { getAccessToken } from '@/components/auth/get-access-token'

export const DEFAULT_CONTEXT: ConfigurationBaseOptions = {
    defaultCurrency: CurrencyCode[CURRENCY],
    defaultCurrencySymbol: CurrencySymbol[CURRENCY],
    featureFlags,
    countryCode: CountryCode.GB,
    locale: Locale.GB,
    timeZone: TimeZone.GB,
    appBasename: getFullBasenamePath(),
    baseUrl: getBaseUrl(),
    rootPath: PATH_FINANCES,
    availableDateRangeFilterShortcuts: [],
    client: {
        url: config.apiUrlBookkeeping,
        token: getAccessToken,
    },
}

export const BookkeepingConfigurationContext = createContext<
    [ConfigurationBaseOptions, Dispatch<SetStateAction<ConfigurationBaseOptions>>]
>([DEFAULT_CONTEXT, () => {}])
